import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=7274c5ba&scoped=true&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=7274c5ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274c5ba",
  null
  
)

export default component.exports